import * as z from 'zod';

export const AccountTypes = ['business', 'freelancer', 'individual'] as const;
export type AccountType = (typeof AccountTypes)[number];

export const OrgTypes = ['llc', 'corp', 'sas', 'sa', 'dao', 'other'] as const;
export type OrgType = (typeof OrgTypes)[number];

export const BusinessProfileSchema = z.object({
  orgType: z.string().min(1, { message: 'Organization type is required' }),
  legalName: z.string().min(1, { message: 'Company name is required' }),
  whatYourCompanyDoes: z.string().optional(),
  country: z.string().min(1, { message: 'Country is required' }),
  state: z.string().min(1, { message: 'State is required' }),
  address1: z.string().min(1, { message: 'Address is required' }),
  postalCode: z.string().min(1, { message: 'Postal code is required' }),
});
export type BusinessProfileData = z.infer<typeof BusinessProfileSchema>;

export const FreelancerProfileSchema = z.object({
  specialty: z.string().min(1, { message: 'Specialty is required' }),
  country: z.string().min(1, { message: 'Country is required' }),
});
export type FreelancerProfileData = z.infer<typeof FreelancerProfileSchema>;

export const IndividualProfileSchema = z.object({
  useCase: z.string().min(1, { message: 'Use case is required' }),
  country: z.string().min(1, { message: 'Country is required' }),
});
export type IndividualProfileData = z.infer<typeof IndividualProfileSchema>;

export const TeamMemberSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1, { message: 'Name is required' }),
  email: z.string().email({ message: 'Valid email is required' }),
  role: z.string().min(1, { message: 'Role is required' }),
});
export type TeamMemberData = z.infer<typeof TeamMemberSchema>;

export type OnboardingForm = {
  accountType: AccountType | null;
  businessProfile: BusinessProfileData;
  freelancerProfile: FreelancerProfileData;
  individualProfile: IndividualProfileData;
  teamMembers: TeamMemberData[];
};
